export const ellipsisText = (text: string, max: number) => { 
    return text && text.length > max 
        ? `${text.substring(0, max)}...`
        : text;
}